import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { LIST_LIMIT_MAX } from '../../../core/constants/network';
import { normalizeList } from '../../../common/package/list';
import { teamKeys } from '../queries/keys';
import { teamPaths } from '../queries/paths';
import { normalizeMember, normalizeProjectTeam, normalizeTeam } from '../utils/normalize';

export function useTeamsList({ q } = {}) {
    const params = { limit: 50 };
    if (q) params.q = q;
    return useQuery({
        queryKey: teamKeys.list(params),
        queryFn: async ({ signal }) => normalizeList((await api.get(teamPaths.list(), { params, signal })).data, normalizeTeam),
    });
}

export function useTeam(id) {
    return useQuery({
        queryKey: teamKeys.detail(id),
        queryFn: async ({ signal }) => normalizeTeam((await api.get(teamPaths.detail(id), { signal })).data),
        enabled: id != null,
    });
}

export function useTeamMembers(id) {
    return useQuery({
        queryKey: teamKeys.members(id),
        queryFn: async ({ signal }) => normalizeList(
            (await api.get(teamPaths.members(id), { params: { limit: LIST_LIMIT_MAX }, signal })).data,
            normalizeMember,
        ),
        enabled: id != null,
    });
}

export function useTeamProjects(teamId) {
    const params = { team_id: teamId, limit: LIST_LIMIT_MAX };
    return useQuery({
        queryKey: teamKeys.projectTeams(params),
        queryFn: async ({ signal }) => normalizeList(
            (await api.get(teamPaths.projectTeams(), { params, signal })).data,
            normalizeProjectTeam,
        ),
        enabled: teamId != null,
    });
}
